<template>
  <div id="projectApplication" v-loading="pageLoading" element-loading-background="rgba(255, 255, 255, 0.4)">
		<el-card class="hiddenBorder">
			<el-tabs v-model="activeTab" @tab-click="handleClick" lazy>
				<!-- companyOrRepresentative === '1'公司级  companyOrRepresentative === '2' 代表处 -->
				<el-tab-pane label="Project Team Member Info" name="10" v-if="companyOrRepresentative === '1' && page === 'projectDetail'">
					<recipient-management :id="id" :allData="allData" ref="recipientManagement" />
				</el-tab-pane>
				<el-tab-pane label="Key Person" name="3" v-if="companyOrRepresentative === '2' && page === 'projectDetail'">
					<el-form :model="keyPersonnelForm" ref="keyPersonnelForm" label-width="260px">
						<el-row>
							<el-col :span="23">
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Project Manager:" prop="projectManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.projectManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => searchManager('projectManagerList', value)"
											>
												<el-option v-for="(item, index) in projectManagerList.slice(0, rangeNumber)" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Deputy Project Manager:" prop="deputyProjectManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.deputyProjectManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => searchManager('deputyProjectManagerList', value)"
											>
												<el-option v-for="(item, index) in deputyProjectManagerList.slice(0, rangeNumber)" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Technical Manager:" prop="developmentLeader" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.developmentLeader"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('developmentLeaderList', value)"
											>
												<el-option v-for="(item, index) in developmentLeaderList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Delivery Manager:" prop="deliveryManager" :rules="[{ required: false, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.deliveryManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('deliveryLeaderList', value)"
											>
												<el-option v-for="(item, index) in deliveryLeaderList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Service Manager:" prop="serviceManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.serviceManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('serviceManagerList', value)"
											>
												<el-option v-for="(item, index) in serviceManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Sales:" prop="salesman" :rules="[{ required: false, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.salesman"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('salesmanList', value)"
											>
												<el-option v-for="(item, index) in salesmanList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="SE:" prop="preSalesTechnicalSupport" :rules="[{ required: false, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.preSalesTechnicalSupport"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('preSalesList', value)"
											>
												<el-option v-for="(item, index) in preSalesList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<!-- <el-col :xs="24" :md="12">
										<el-form-item label="Account Manager:" prop="customerManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.customerManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('customerManagerList', value)"
											>
												<el-option v-for="(item, index) in customerManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col> -->
								</el-row>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="Basic Project Info" name="1">
					<el-form :model="majorProjectForm" ref="majorProjectForm" label-width="260px">
						<el-row>
							<el-col :span="23">
								<el-row>
									<el-col :span="0">
										<el-form-item prop="id">
											<el-input  v-model="majorProjectForm.id" />
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="IPMS ID/PMS ID:" prop="ipmsId" :rules="[{ required: true, message: 'Please input' }]" class="ipmslabel">
											<!-- <el-input clearable v-model="majorProjectForm.ipmsId" maxlength="255" placeholder="Please input" :disabled="editDisabled" @change="changeIpms" @blur="getIpmsInfo" /> -->
											<!-- <el-select
												clearable
												filterable
												remote
												v-model="majorProjectForm.ipmsId"
												maxlength="255"
												:remote-method="searchIpms"
												@change="getIpmsInfo"
												:disabled="editDisabled"
												:loading="searchLoading"
												placeholder="Please input"
											>
												<el-option
													v-for="item in ipmsList"
													:key="item"
													:label="item"
													:value="item"
												>
												</el-option>
											</el-select> -->
											<el-autocomplete
												v-model="majorProjectForm.ipmsId"
												:fetch-suggestions="querySearchAsync"
												placeholder="Please input"
												:disabled="editDisabled"
												@select="getIpmsInfo"
											>
											</el-autocomplete>
											<el-tooltip class="item" effect="dark" content="After entering the IPMS ID/PMS ID, relevant project information will be associated and displayed, and this information can also be updated according to actual needs, such as the project name." placement="top-start">
												<i class="el-icon-question icon-label" />
											</el-tooltip>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Project Name:" prop="projectName" :rules="[{ required: true, message: 'Please input' }]">
											<el-input clearable v-model="majorProjectForm.projectName" maxlength="255" placeholder="Please input" :disabled="editDisabled" />
											<el-tooltip class="item" effect="dark" content="Suggest：use the project name automatically associated with IPMS ID/PMS ID. If the project name does not match the automatically associated project name, it may lead to a failure in the customer satisfaction rate survey." placement="top-start">
												<i class="el-icon-question icon-label" />
											</el-tooltip>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Product Order:" prop="productOrderList" :rules="[{ required: false, message: 'Please input' }]">
											<el-input v-model="majorProjectForm.productOrderList" :disabled="editDisabled" placeholder="Please input" />
											<el-tooltip class="item" effect="dark" content='Eparated by semicolon "," (English input method).' placement="top-start">
												<i class="el-icon-question icon-label" />
											</el-tooltip>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Service Contract:" prop="serviceContractList" :rules="[{ required: false, message: 'Please input' }]">
											<el-input v-model="majorProjectForm.serviceContractList" :disabled="editDisabled" placeholder="Please input" />
											<el-tooltip class="item" effect="dark" content='Eparated by semicolon "," (English input method).' placement="top-start">
												<i class="el-icon-question icon-label" />
											</el-tooltip>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Project Order (Product):" prop="projectProductOrderList" :rules="[{ required: false, message: 'Please input' }]">
											<el-input v-model="majorProjectForm.projectProductOrderList" :disabled="editDisabled" placeholder="Please input" />
											<el-tooltip class="item" effect="dark" content='Eparated by semicolon "," (English input method).' placement="top-start">
												<i class="el-icon-question icon-label" />
											</el-tooltip>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Project Order (Service):" prop="projectServiceOrderList" :rules="[{ required: false, message: 'Please input' }]">
											<el-input v-model="majorProjectForm.projectServiceOrderList" :disabled="editDisabled" placeholder="Please input" />
											<el-tooltip class="item" effect="dark" content='Eparated by semicolon "," (English input method).' placement="top-start">
												<i class="el-icon-question icon-label" />
											</el-tooltip>
										</el-form-item>
									</el-col>
								</el-row>
								<!-- <el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Project Amount（KUSD）:" prop="estimatedProjectAmount" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0" :precision="2" :controls="false" v-model="majorProjectForm.estimatedProjectAmount" maxlength="255" placeholder="Please input" :disabled="editDisabled" />
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Service Amount（KUSD）:" prop="estimatedServiceAmount" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0" :precision="2" :controls="false" v-model="majorProjectForm.estimatedServiceAmount" maxlength="255" placeholder="Please input" :disabled="editDisabled" />
										</el-form-item>
									</el-col>
								</el-row> -->
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Product Type:" prop="productType" :rules="[{ required: true, message: 'Please input' }]">
											<el-input clearable v-model="majorProjectForm.productType" maxlength="255" placeholder="Please input" :disabled="editDisabled" />
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Major Project Type:" prop="majorProjectType" :rules="[{ required: true, message: 'Please select' }]">
											<el-select clearable v-model="majorProjectForm.majorProjectType" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in majorProjectType"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Engineering Type:" prop="projectTypeList" :rules="[{ required: true, message: 'Please select' }]">
											<el-select multiple clearable v-model="majorProjectForm.projectTypeList" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in engineeringType"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Major Project Category:" prop="majorProjectCategoryList" :rules="[{ required: true, message: 'Please select' }]">
											<el-select multiple clearable v-model="majorProjectForm.majorProjectCategoryList" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in majorProjectCategory"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Major Project Level:" prop="majorProjectLevel" :rules="[{ required: true, message: 'Please select' }]">
											<el-select clearable v-model="majorProjectForm.majorProjectLevel" :disabled="editDisabled || disableProjectLevel" placeholder="Please select">
												<el-option
													v-for="item in majorProjectLevel"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
											<el-tooltip class="item" effect="dark" content="Please refer to: Explanation of Project Initiation Levels for Major Deliverables." placement="top-start">
												<i class="el-icon-question icon-label" />
											</el-tooltip>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Department:" prop="department" :rules="[{ required: true, message: 'Please select' }]">
											<el-select filterable v-model="majorProjectForm.department" :disabled="editDisabled" clearable placeholder="Please select">
												<el-option v-for="item in deptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<!-- <el-form-item label="Project Plan Date:" prop="projectPlanDate" :rules="[{ required: true, message: 'Please select' }]">
											<el-date-picker
												v-model="majorProjectForm.projectPlanDate"
												type="daterange"
												range-separator="-"
												start-placeholder="Start date"
												end-placeholder="End date"
												placeholder="Please select"
												value-format="yyyy-MM-dd HH:mm:ss"
											>
											</el-date-picker>
										</el-form-item> -->
										<el-form-item
											label="Estimated Delivery Start Date:"
											prop="projectPlanStartDate"
											:rules="[
												{ required: true, message: 'Please select', trigger: 'change' },
												{ validator: this.validateTime, trigger: 'change' }
											]">
											<el-date-picker
												v-model="majorProjectForm.projectPlanStartDate"
												type="date"
												range-separator="-"
												placeholder="Please select"
												value-format="yyyy-MM-dd"
												:disabled="editDisabled"
											>
											</el-date-picker>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item
											label="Estimated Delivery Finish Date:"
											prop="projectPlanEndDate"
											:rules="[
												{ required: true, message: 'Please select', trigger: 'change' },
												{ validator: this.validateTime, trigger: 'change' }
											]">
											<el-date-picker
												v-model="majorProjectForm.projectPlanEndDate"
												type="date"
												range-separator="-"
												placeholder="Please select"
												value-format="yyyy-MM-dd"
												:disabled="editDisabled"
											>
											</el-date-picker>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12" v-if="majorProjectForm.majorProjectLevel && majorProjectForm.majorProjectLevel!== 4">
										<el-form-item label="Labor-hour Assessment (Person-day)	:" class="longlabel" prop="deliveryLabourHour" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0" :precision="2" :controls="false" v-model="majorProjectForm.deliveryLabourHour" placeholder="Please input" :disabled="true" />
												<el-tooltip class="item" effect="dark" content='The data is summarized by the key milestone“Labor-hour Assessment(Person-day)”.' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
										<el-form-item label="Labor-hour Assessment (Mgmt.)(Person-day) :" class="longlabel" prop="mgmtHours" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0" :precision="2" :controls="false" v-model="majorProjectForm.mgmtHours" placeholder="Please input" :disabled="true" />
												<el-tooltip class="item" effect="dark" content='The data is summarized by the key milestone“Labor-hour Assessment(Person-day)”which work attribute is Mgmt.' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
										<el-form-item label="Labor-hour Assessment(Delivery) (Person-day) :" class="longlabel" prop="deliveryHours" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0" :precision="2" :controls="false" v-model="majorProjectForm.deliveryHours" placeholder="Please input" :disabled="true" />
												<el-tooltip class="item" effect="dark" content='The data is summarized by the key milestone“Labor-hour Assessment(Person-day)”which work attribute is Delivery.' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
										<el-form-item label="Actual happened Labor-hour (Mgmt.)(Hour) :" class="longlabel" prop="mgmtActualHours" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0" :precision="2" :controls="false" v-model="majorProjectForm.mgmtActualHours" placeholder="Please input" :disabled="true" />
												<el-tooltip class="item" effect="dark" content='The actual applied labor-hour(Mgmt.) in this project' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
										<el-form-item label="Labor-Hour Mgmt. Assessment Accuracy :" class="longlabel" prop="estVsActHoursRatio" :rules="[{ required: true, message: 'Please input' }]">
											<div class="custom-input-number">
												<el-input-number clearable :min="0" :precision="2" :controls="false" v-model="majorProjectForm.estVsActHoursRatio * 100" placeholder="Please input" :disabled="true"/>
												<span class="suffix">%</span>
											</div>
												<el-tooltip class="item" effect="dark" content='Actual happened Labor-hour (Mgmt.)(Hour) /8/ Labor-hour Assessment (Mgmt.)(Person-day)*100%' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
									</el-col>
									
									<el-col :xs="24" :md="12" v-if="majorProjectForm.majorProjectLevel && majorProjectForm.majorProjectLevel=== 4">
										<el-form-item label="Labor-hour Assessment (Mgmt.)(Person-day) :" class="longlabel" prop="mgmtHours" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0" :precision="0" :disabled="editDisabled" :controls="false" v-model.number="majorProjectForm.mgmtHours" placeholder="Please input" />
												<el-tooltip class="item" effect="dark" content='The project manager manually enters after evaluation and cannot make changes.' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
										<el-form-item label="Actual happened Labor-hour (Mgmt.)(Hour) :" class="longlabel" prop="mgmtActualHours" :rules="[{ required: true, message: 'Please input' }]">
											<el-input-number clearable :min="0"  :precision="2" :disabled="true" :controls="false" v-model.number="majorProjectForm.mgmtActualHours" placeholder="Please input" />
												<el-tooltip class="item" effect="dark" content='The actual applied labor-hour(Mgmt.) in this project' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
										<el-form-item label="Labor-Hour Mgmt. Assessment Accuracy :" class="longlabel" prop="estVsActHoursRatio" :rules="[{ required: true, message: 'Please input' }]">
											<div class="custom-input-number">
												<el-input-number clearable :min="0"  :precision="2" :disabled="true" :controls="false" v-model.number="majorProjectForm.estVsActHoursRatio * 100" placeholder="Please input"/>
												<span class="suffix">%</span>
											</div>
												<el-tooltip class="item" effect="dark" content='Actual happened Labor-hour (Mgmt.)(Hour) /8/ Labor-hour Assessment (Mgmt.)(Person-day)*100%' placement="top-start">
													<i class="el-icon-question icon-label" />
												</el-tooltip>
											</el-form-item>
									</el-col>

									<el-col :xs="24" :md="12">
										<el-form-item label="Solution One-Stop E-flow ID:" prop="entrustElectronicFlowId">
											<el-input clearable v-model="majorProjectForm.entrustElectronicFlowId" maxlength="255" placeholder="Please input" :disabled="editDisabled" />
										</el-form-item>
									</el-col>
								<!-- </el-row>
								<el-row> -->
									<el-col :xs="24" :md="12">
										<el-form-item label="Sales Region:" prop="salesRegion" :rules="[{ required: true, message: 'Please select' }]">
											<el-select clearable filterable v-model="majorProjectForm.salesRegion" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in salesRegionList"
													:key="item"
													:label="item"
													:value="item"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Direct Deal:" prop="directCustomerSigning" :rules="[{ required: true, message: 'Please select' }]">
											<el-select clearable v-model="majorProjectForm.directCustomerSigning" :disabled="editDisabled" @change="changeDirectCustomerSigning" placeholder="Please select">
												<el-option
													v-for="item in yesOrNo"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								<!-- </el-row>
								<el-row> -->
									<el-col :xs="24" :md="12" v-if="majorProjectForm.directCustomerSigning === 0">
										<el-form-item label="Channel Name:" prop="channelName" :rules="[{ required: majorProjectForm.directCustomerSigning !== 1, message: 'Please input' }]">
											<!-- <el-input clearable v-model="majorProjectForm.channelName" maxlength="255" placeholder="Please input" :disabled="majorProjectForm.directCustomerSigning === 1 || editDisabled" /> -->
											<el-select
												clearable
												filterable
												remote
												v-model="majorProjectForm.channelName"
												maxlength="255"
												:remote-method="searchChannelName"
												:disabled="majorProjectForm.directCustomerSigning === 1 || editDisabled"
												:loading="searchLoading"
												placeholder="Please input"
												@change="changeChannelName"
											>
												<el-option
													v-for="item in channelNameList"
													:key="item.companyName"
													:label="item.companyName"
													:value="item.companyName"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12" v-if="majorProjectForm.directCustomerSigning === 0">
										<el-form-item label="Channel Qualification:" prop="channelQualification">
											<el-input clearable v-model="majorProjectForm.channelQualification" maxlength="255" placeholder="Please input" disabled />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="3S2S:" prop="project3S2S" class="ipmslabel">
											<el-input clearable :value="majorProjectForm && majorProjectForm.source === '3S2S' ? 'Yes' : 'No'" :disabled="true" />
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="3S2S Management Project Start Date:" prop="s3s2sManagementStartDate" :rules="[{ required: false, message: 'Please select', trigger: 'change' }]">
											<el-date-picker
												v-model="majorProjectForm.s3s2sManagementStartDate"
												type="date"
												placeholder="Please select"
												value-format="yyyy-MM-dd"
												:disabled="true"
											>
											</el-date-picker>
										</el-form-item>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="Customer Info" name="2">
					<el-form :model="customerInfoForm" ref="customerInfoForm" label-width="260px">
						<el-row>
							<el-col :span="23">
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Customer Name:" prop="customerName" :rules="[{ required: true, message: 'Please input' }]">
											<!-- <el-input clearable v-model="customerInfoForm.customerName" maxlength="255" placeholder="Please input" :disabled="editDisabled" @focus="openCustomer" /> -->
											<el-input clearable v-model="customerInfoForm.customerName" maxlength="255" placeholder="Please input" :disabled="editDisabled"  />
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Sub Industry:" prop="customerIndustry" :rules="[{ required: true, message: 'Please select' }]">
											<el-input clearable v-model="customerInfoForm.customerIndustry" maxlength="255" placeholder="Please input" :disabled="editDisabled"  />
											<!-- <el-select clearable v-model="customerInfoForm.customerIndustry" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in customerIndustry"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select> -->
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="BG:" prop="bg" :rules="[{ required: true, message: 'Please select' }]">
											<el-select clearable v-model="customerInfoForm.bg" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in BG"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Whitelist Customer:" prop="whitelistCustomers" :rules="[{ required: true, message: 'Please select' }]">
											<el-select clearable v-model="customerInfoForm.whitelistCustomers" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in yesOrNo"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<!-- <el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Customer Level:" prop="customerLevel" :rules="[{ required: true, message: 'Please select' }]">
											<el-select clearable v-model="customerInfoForm.customerLevel" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in customerLevel"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row> -->
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="Key Person" name="3" v-if="page !== 'projectDetail'">
					<el-form :model="keyPersonnelForm" ref="keyPersonnelForm" label-width="260px">
						<el-row>
							<el-col :span="23">
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Project Manager:" prop="projectManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.projectManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => searchManager('projectManagerList', value)"
												@change="changeMilestone"
											>
												<el-option v-for="(item, index) in projectManagerList.slice(0, rangeNumber)" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Deputy Project Manager:" prop="deputyProjectManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.deputyProjectManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => searchManager('deputyProjectManagerList', value)"
											>
												<el-option v-for="(item, index) in deputyProjectManagerList.slice(0, rangeNumber)" :key="index" :label="item.empName + ' ' + item.empCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Technical Manager:" prop="developmentLeader" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.developmentLeader"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('developmentLeaderList', value)"
											>
												<el-option v-for="(item, index) in developmentLeaderList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Delivery Manager:" prop="deliveryManager" :rules="[{ required: false, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.deliveryManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('deliveryLeaderList', value)"
											>
												<el-option v-for="(item, index) in deliveryLeaderList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Service Manager:" prop="serviceManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.serviceManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('serviceManagerList', value)"
											>
												<el-option v-for="(item, index) in serviceManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Sales:" prop="salesman" :rules="[{ required: false, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.salesman"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('salesmanList', value)"
											>
												<el-option v-for="(item, index) in salesmanList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="SE:" prop="preSalesTechnicalSupport" :rules="[{ required: false, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.preSalesTechnicalSupport"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('preSalesList', value)"
											>
												<el-option v-for="(item, index) in preSalesList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<!-- <el-col :xs="24" :md="12">
										<el-form-item label="Account Manager:" prop="customerManager" :rules="[{ required: true, message: 'Please input' }]">
											<el-select
												v-model="keyPersonnelForm.customerManager"
												clearable
												filterable
												remote
												placeholder="Please input"
												:disabled="editDisabled"
												:remote-method="value => remoteMethod('customerManagerList', value)"
											>
												<el-option v-for="(item, index) in customerManagerList" :key="index" :label="item.userCode" :value="item.empCode"></el-option>
											</el-select>
										</el-form-item>
									</el-col> -->
								</el-row>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="Project Configuration Info" name="4">
					<el-form :model="projectConfigurationForm" ref="projectConfigurationForm" label-width="260px">
						<el-row>
							<el-col :span="23">
								<el-row>
									<el-col :span="24">
										<el-form-item label="Project Importance:" prop="projectImportance" :rules="[{ required: majorProjectForm.majorProjectLevel !== 4, message: 'Please input' }]">
											<el-input type="textarea" clearable v-model="projectConfigurationForm.projectImportance" maxlength="1000" placeholder="Please input" :disabled="editDisabled" />
										</el-form-item>
									</el-col>
									<el-col :span="24">
										<el-form-item label="Contract Configuration:" prop="contractConfiguration" :rules="[{ required: majorProjectForm.majorProjectLevel !== 4, message: 'Please input' }]">
											<el-input type="textarea" clearable v-model="projectConfigurationForm.contractConfiguration" maxlength="1000" placeholder="Please input" :disabled="editDisabled" />
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :xs="24" :md="12">
										<el-form-item label="Node Name:" prop="nodeName" :rules="[{ required: majorProjectForm.majorProjectLevel !== 4, message: 'Please input' }]">
											<el-input clearable v-model="projectConfigurationForm.nodeName" maxlength="255" placeholder="Please input" :disabled="editDisabled" />
										</el-form-item>
									</el-col>
									<el-col :xs="24" :md="12">
										<el-form-item label="Factory Inspection:" prop="factoryInspection" :rules="[{ required: majorProjectForm.majorProjectLevel !== 4, message: 'Please select' }]">
											<el-select clearable v-model="projectConfigurationForm.factoryInspection" :disabled="editDisabled" placeholder="Please select">
												<el-option
													v-for="item in yesOrNo"
													:key="item.labelKey"
													:label="item.labelValue"
													:value="item.labelKey"
													:disabled="editDisabled"
												>
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24">
										<el-form-item
											label="Pre-sales Solution:"
											prop="preSalesSolution"
											:rules="[
												{
													required: majorProjectForm.majorProjectLevel !== 4,
													message: 'Please upload',
												},
											]"
										>
											<el-upload
												class="upload-demo"
												action="#"
												:http-request="changeFile"
												:file-list="fileList"
												:show-file-list="false"
												:before-upload="beforeUpload"
												:limit="1"
												:on-exceed="handleExceed"
												v-model="projectConfigurationForm.preSalesSolution"
											>
												<el-button size="small" type="primary" :disabled="!(this.flowCanEdit === true || this.page == '')">Upload</el-button>
											</el-upload>
											<div class="el-upload-newlist">
												<div v-for="(item, index) in fileList" :key="index" class="el-upload-file-box">
													<a class="file-name" @click="handlePreview(item)"><i class="el-icon-document" />{{ item.name }}</a>
													<label>
														<span class="percentage" v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100">{{ item.uploadPercentage }}%</span>
														<i class="el-icon-circle-check icon-check" style="color: #67c23a" v-if="item.id || item.uploadPercentage === 100"></i>
														<i class="el-icon-close icon-close" style="display: none" @click="handleRemove"></i>
													</label>
													<el-progress v-if="item.uploadPercentage > 0 && item.uploadPercentage < 100" :show-text="false" :stroke-width="2" :percentage="item.uploadPercentage"></el-progress>
												</div>
											</div>
										</el-form-item>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="Risk Management" name="5" v-if="page !== 'projectDetail'">
					<el-form :model="riskManagementForm" ref="riskManagementForm" label-width="200px">
						<el-row>
							<el-col :span="23">
								<el-row class="risk-row" v-for="(risk, index) in riskManagementForm.projectApplyRiskType" :key="index">
									<el-col :span="24">
										<el-form-item
											:label="risk.riskType"
											label-width="200px"
											:prop="'projectApplyRiskType.' + index + '.isRisk'"
											:rules="{
												required: true, message: 'Please select'
											}"
										>
											<el-radio-group clearable v-model="risk.isRisk" placeholder="Please select" :disabled="editDisabled">
												<el-radio v-for="item in yesOrNo" :label="item.labelKey" :key="item.labelKey">{{ item.labelValue }}</el-radio>
											</el-radio-group>
										</el-form-item>
									</el-col>
									<el-col :span="24" v-if="risk.isRisk === 1" style="margin-top: -10px">
										<el-form-item label="" label-width="200px" :prop="'projectApplyRiskType.' + index + '.riskDesc'" :rules="[{ required: true, message: 'Please input' }]">
											<el-input type="textarea" clearable v-model="risk.riskDesc" :disabled="editDisabled" maxlength="255" placeholder="Please input the risk description." />
										</el-form-item>
									</el-col>
									<el-col :span="24" v-if="risk.isRisk === 1">
										<el-form-item label="" label-width="200px" :prop="'projectApplyRiskType.' + index + '.responseMeasures'" :rules="[{ required: true, message: 'Please input' }]">
											<el-input type="textarea" clearable v-model="risk.responseMeasures" :disabled="editDisabled" maxlength="255" placeholder="Please input the Response Measures." />
										</el-form-item>
									</el-col>
								</el-row>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="Major Project Initiation" name="6" v-if="majorProjectForm.proposalStatus === 1 && page !== 'projectDetail'">
					<el-form :model="formallyForm" ref="formallyForm" label-width="260px">
						<el-row>
							<el-col :span="24">
								<el-form-item label="Service Delivery Notice Number:" prop="serviceDeliveryNotificationNumber">
									<el-input clearable v-model="formallyForm.serviceDeliveryNotificationNumber" :disabled="true" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="Major Project Initiation Date:" prop="officialProjectLaunchTime">
									<el-date-picker
										v-model="formallyForm.officialProjectLaunchTime"
										type="datetime"
										value-format="yyyy-MM-dd HH:mm:ss" 
										placeholder="Please select"
										:disabled="true"
									>
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="Official Project Document:" prop="officialReleaseFile">
									<el-upload
										class="upload-demo"
										:action="this.$store.state.islhurl + '/s3/upload'"
										:before-upload="beforeUpload"
										:limit="1"
										:file-list="officialReleaseFileList"
										:on-preview="handlePreview"
										:before-remove="beforeRemove"
										:auto-upload="false"
										v-model="formallyForm.officialReleaseFile"
									>
										<el-button size="small" type="primary" :disabled="true">Upload</el-button>
									</el-upload>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>
				<el-tab-pane label="Project Milestone Planning" name="7" v-if="page !== 'projectDetail' && majorProjectForm.majorProjectLevel && majorProjectForm.majorProjectLevel!== 4">
					<milestone-list
						ref="milestonelist"
						:canEdit="!editDisabled"
						:milestoneStatus="milestoneStatus"
						:AttributeList="AttributeList"
						@setDays="setDays"
						@setMgmt="setMgmt"
						@setDelivery="setDelivery"
						:projectPlanStartDate="majorProjectForm.projectPlanStartDate"
						:projectPlanEndDate="majorProjectForm.projectPlanEndDate"
					/>
				</el-tab-pane>
			</el-tabs>
			<customer-list ref="customerlist" @setCustomerName="setCustomerName" />
			<p v-if="reason" style="padding-left: 131px;color: red;font-size: 14px;margin-top: -20px;">{{ reason }}</p>
			<el-row :span="24">
				<el-col style="padding: 10px 0 20px 0; text-align: center;" :span="24">
					<el-button type="primary" @click="handleBack()" v-if="this.page === 'toDo' || this.page === 'myFlow' || this.page === 'project3S2S' || this.page === 'flowQuery' || this.page === 'formallyAproved' || this.page === 'projectApproval'">Return</el-button>
					<el-button :loading="saveLoading" @click="handleSave()" v-if="this.flowCanEdit === true || this.page == ''">Save</el-button>
					<el-button type="primary" :loading="submitLoading" @click="handleSubmit()" v-if="(this.flowCanEdit == true || this.page == '') && !hideSubmit">Submit</el-button>
				</el-col>
      </el-row>
		</el-card>
  </div>
</template>
<script>
  import {_debounce} from '@/utils/selectAPI'
  import * as validate from '@/utils/validate'
	import axios from 'axios'
	import moment from 'moment'
	import recipientManagement from '../recipientManagement';
  import customerList from './customerList.vue';
	import milestoneList from './milestoneList.vue';
  export default {
    name: 'projectApplication',
		components: {
			customerList,
			recipientManagement,
			milestoneList,
		},
		props: {
			id: {
        type: Number,
        default: null,
      },
			page: {
        type: String,
        default: '',
      },
			companyOrRepresentative: {
        type: String,
        default: '',
      },
			flowCanEdit: {
        type: Boolean,
        default: false,
      },
			hideSubmit: {
        type: Boolean,
        default: false,
      },
			disableProjectLevel: {
        type: Boolean,
        default: false,
      },
		},
    created () {
			this.getSelectInfo();
			this.getDeptList();
			this.getCountry();
			if(this.id) {
				this.getDetailInfo(this.id)
			} else {
				this.getUserList();
			}
		},
    data () {
			// let editDisabled = this.page !== '' && this.page !== 'myFlow';
			let editDisabled = this.page !== '' && this.flowCanEdit !== true;
      return {
				pageLoading: false,
				editDisabled,
				activeTab: this.page === 'projectDetail' ? (this.companyOrRepresentative === '1' ? '10' : '3') : '1',
				ipmsList: [],
				searchLoading: false,
				majorProjectType: [],
				engineeringType: [],
				majorProjectCategory: [],
				majorProjectLevel: [], // {Company Premium Level :1,Company First Level :2,Company Second Level :3,Representation Office Level :4}
        majorProjectForm: {
					majorProjectCategoryList: [],
					projectTypeList: [],
					projectPlanStartDate: null,
					projectPlanEndDate: null,
					s3s2sManagementStartDate: null,
					deliveryLabourHour: undefined,
					mgmtActualHours: 0,
					estVsActHoursRatio:0,
				},
				customerIndustry: [],
				BG: [],
				// whitelistCustomers: [],
				// directCustomerSigning: [],
				yesOrNo: [
					{
						labelValue: 'Yes',
						labelKey: 1,
					},
					{
						labelValue: 'No',
						labelKey: 0,
					},
				],
				salesRegionList: [],
				customerLevel: [],
				customerLevelAll: [],
				milestoneStatus: [],
				AttributeList: [
					{
						labelKey:1,
						labelValue:'Mgmt.'
					}, {
						labelKey: 2,
						labelValue:'Delivery'
					}
				],
				// factoryInspection: [],
				fileList: [],
				projectManagerList: [],
				deputyProjectManagerList: [],
				projectManagerAllList: [],
				developmentLeaderList: [],
				deliveryLeaderList: [],
				serviceManagerList: [],
				salesmanList: [],
				preSalesList: [],
				customerManagerList: [],
				rangeNumber: 10,
				deptList: [],
				// projectApplyRiskType: [],
				customerInfoForm: {},
				keyPersonnelForm: {},
				projectConfigurationForm: {},
				riskManagementForm: {
					projectApplyRiskType: [],
				},
				projectApplyRiskTypeInit: [],
				projectApplyRiskTypeDetail: [],
				saveLoading: false,
				submitLoading: false,
				formallyForm: {},
				officialReleaseFileList: [],
				reason: null,
				channelNameList: [],
				allData: {},
				preSalesPlanFileId: '',
				cancelUpload: null, // 存储取消上传的函数
      }
    },
    methods: {
			getDetailInfo() {
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				let url =`${this.$store.state.islhurl}majorProject/getById?id=${this.id}`;
				if(this.page !== 'projectDetail') {
					this.pageLoading = true
				}
				this._post(url,params).then(
					res => {
						if(res.code === 200) {
							const info = res.data;
							this.allData = info;
							if(this.page === 'projectDetail') {
								this.$emit('setInfo', res.data)
							}
							// if(info.estimatedProjectAmount === null) delete info.estimatedProjectAmount;
							// if(info.estimatedServiceAmount === null) delete info.estimatedServiceAmount;
							if(info.deliveryLabourHour === null) delete info.deliveryLabourHour;
							this.majorProjectForm = {
								...info,
								projectPlanStartDate: info.projectPlanStartDate ? moment(info.projectPlanStartDate).format('YYYY-MM-DD') : null,
								projectPlanEndDate: info.projectPlanEndDate ? moment(info.projectPlanEndDate).format('YYYY-MM-DD') : null,
								s3s2sManagementStartDate: info.s3s2sManagementStartDate ? moment(info.s3s2sManagementStartDate).format('YYYY-MM-DD') : null,
								serviceContractList: info.serviceContractList ? info.serviceContractList.join(',') : '',
								productOrderList: info.productOrderList ? info.productOrderList.join(',') : '',
								projectServiceOrderList: info.projectServiceOrderList ? info.projectServiceOrderList.join(',') : '',
								projectProductOrderList: info.projectProductOrderList ? info.projectProductOrderList.join(',') : '',
							}
							if(info.proposalStatus === 1) {
								this.formallyForm = {
									serviceDeliveryNotificationNumber: info.serviceDeliveryNotificationNumber,
									officialProjectLaunchTime: info.officialProjectLaunchTime,
									officialReleaseFile: info.officialReleaseFileName,
								}
								if(info.officialReleaseFileName) {
									this.officialReleaseFileList = [{
										fileName: info.officialReleaseFileName,
										name: info.officialReleaseFileName,
										fileAliasName: info.officialReleaseFileAliasName,
										url: `${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(info.officialReleaseFileAliasName)}&fileName=${encodeURIComponent(info.officialReleaseFileName)}`
									}]
								}
							}
							this.customerInfoForm = {
								customerName: info.customerName,
								customerIndustry: info.customerIndustry,
								bg: info.bg,
								whitelistCustomers: info.whitelistCustomers,
								// customerLevel: info.customerLevel,
							};
							this.keyPersonnelForm = {
								projectManager: info.projectManager,
								developmentLeader: info.developmentLeader,
								serviceManager: info.serviceManager,
								salesman: info.salesman,
								preSalesTechnicalSupport: info.preSalesTechnicalSupport,
								// customerManager: info.customerManager,
								deputyProjectManager: info.deputyProjectManager,
								deliveryManager: info.deliveryManager,
							};
							this.projectConfigurationForm = {
								projectImportance: info.projectImportance,
								contractConfiguration: info.contractConfiguration,
								nodeName: info.nodeName,
								factoryInspection: info.factoryInspection,
							};
							// risk
							if(this.projectApplyRiskTypeInit && this.projectApplyRiskTypeInit.length > 0 && info.riskList) {
								let projectApplyRiskType = [];
								this.projectApplyRiskTypeInit.forEach(item => {
									const index = info.riskList.findIndex((risk) => risk.riskType === item.labelKey);
									projectApplyRiskType.push({
										...item,
										id: index > -1 ? info.riskList[index].id: null,
										isRisk: index > -1 ? 1: 0,
										riskType: item.labelValue,
										riskTypeKey: item.labelKey,
										riskDesc: index > -1 ? info.riskList[index].riskDesc: '',
										responseMeasures: index > -1 ? info.riskList[index].responseMeasures: '',
									})
								})
								this.riskManagementForm =  {
									projectApplyRiskType,
								}
							} else if (info.riskList && info.riskList.length>  0) {
								this.projectApplyRiskTypeDetail = info.riskList;
							}
							// if(info.majorProjectLevel!==4){
							// 	this.changeLHA(info.milestoneList)
							// }
							// 回显人员
							// remoteMethod(list, query)
							this.getUserList('detail')
							// setTimeout(() => {
							// 	if(info.projectManager) this.searchManager('projectManagerList', info.projectManager);
							// 	if(info.developmentLeader) this.remoteMethod('developmentLeaderList', info.developmentLeader);
							// 	if(info.serviceManager) this.remoteMethod('serviceManagerList', info.serviceManager);
							// 	if(info.salesman) this.remoteMethod('salesmanList', info.salesman);
							// 	if(info.preSalesTechnicalSupport) this.remoteMethod('preSalesList', info.preSalesTechnicalSupport);
							// 	if(info.customerManager) this.remoteMethod('customerManagerList', info.customerManager);
							// }, 1500);
							// 附件
							if(info.preSalesPlanFileName) {
								this.fileList = [{
									fileName: info.preSalesPlanFileName,
									name: info.preSalesPlanFileName,
									fileAliasName: info.preSalesPlanFileAliasName,
									id: info.preSalesPlanFileId,
									url: `${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(info.preSalesPlanFileAliasName)}&fileName=${encodeURIComponent(info.preSalesPlanFileName)}`
								}]
								this.projectConfigurationForm = {
									...this.projectConfigurationForm,
									preSalesSolution: [{fileName: info.preSalesPlanFileName}]
								};
							}
							this.preSalesPlanFileId = info.preSalesPlanFileId
							if(info.projectStatus === 7 && info.reason) {
								this.reason = 'Reason for Discard:   ' + info.reason;
							}
							this.$nextTick(() => {
								this.clearFormValidate();
								if(this.page !== 'projectDetail' && info.majorProjectLevel && info.majorProjectLevel !== 4) {
									this.$refs.milestonelist.setData(res.data.milestoneList);
								}
							});
						}
						this.pageLoading = false
					}
				)
			},
			changeLHA(data) {
      let allMgmt = 0;
      let allDelivery = 0;
      data.forEach((item, index) => {
        if (data.length > 1 && index < data.length - 1) {
          if (item.workAttribute == 1) {
            allMgmt+=(item.estimatedWorkload||0)
          }
          if (item.workAttribute == 2) {
            allDelivery += (item.estimatedWorkload || 0)
          }
        }
      })
      this.setMgmt(allMgmt.toFixed(2));
      this.setDelivery(allDelivery.toFixed(2));
    },
			getSelectInfo() {
				let url = `${this.$store.state.islhurl}configMain/queryLabelList?`;
				let configKeyList = [
					'majorProjectType',
					'majorProjectCategory',
					'majorProjectLevel',
					// 'customerIndustry',
					'BG',
					// 'customerLevel',
					'projectApplyRiskType',
					'engineeringType',
					'milestoneStatus'
					// 'whitelistCustomers',
					// 'directCustomerSigning',
					// 'factoryInspection',
					// 'projectRiskType',
					// 'riskLevel',
					// 'applyStatus',
					// 'projectStatus',
					// 'flowType',
				]
				let str = '';
				configKeyList.forEach(item => {
					str += `&configKeyList=${item}`;
				})
				url = url + str.substring(1)
				const _this = this
				this._post(url).then(
					res => {
						if (res.data && res.code === 200) {
							Object.keys(res.data).forEach(function(key) {
								if(key !== 'projectApplyRiskType') {
									_this[key] = res.data[key];
								} else {
									_this.projectApplyRiskTypeInit = res.data[key]
									let projectApplyRiskType = [];
									res.data[key].forEach(item => {
										const index = _this.projectApplyRiskTypeDetail.findIndex((risk) => risk.riskType === item.labelKey);
										projectApplyRiskType.push({
											riskType: item.labelValue,
											riskTypeKey: item.labelKey,
											id: index > -1 ? _this.projectApplyRiskTypeDetail[index].id :0,
											isRisk: index > -1 ? 1 :0,
											riskDesc: index > -1 ? _this.projectApplyRiskTypeDetail[index].riskDesc : '',
											responseMeasures: index > -1 ? _this.projectApplyRiskTypeDetail[index].responseMeasures : '',
										})
									})
									_this.riskManagementForm =  {
										projectApplyRiskType: projectApplyRiskType,
									}
								}
							});
							// this.customerLevelAll = res.data.customerLevel;
						}
					}
				)
			},
			getUserList(type) {
				if (type === 'detail') {
					let url =`${this.$store.state.islhurl}user/batch-get`;
					const { developmentLeader, deliveryManager, serviceManager, salesman, preSalesTechnicalSupport } = this.majorProjectForm;
					const validValues = [
						developmentLeader,
						deliveryManager,
						serviceManager,
						salesman,
						preSalesTechnicalSupport
					].filter(value => value != null && value !== "");
					let obj = {
						empCodeList: validValues
					}
					this._post(url, obj).then(
						res => {  
							if(res.code === 200 && res.data) {
								console.log(res.data)
								this.developmentLeaderList = res.data
								this.deliveryLeaderList = res.data
								this.serviceManagerList = res.data
								this.salesmanList = res.data
								this.preSalesList = res.data
							}
						}
					)
				}
				let url2 =`${this.$store.state.islhurl}majorProjectManager/fuzzyQueryByName?empName=`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url2, params).then(
					res => {  
						if(res) {
							this.projectManagerList = res
							this.deputyProjectManagerList = res
							this.projectManagerAllList = res
							if(type === 'detail') {
								const info = this.majorProjectForm
								if(info.projectManager) this.searchManager('projectManagerList', info.projectManager);
								if(info.deputyProjectManager) this.searchManager('deputyProjectManagerList', info.deputyProjectManager);
							}
						}
					}
				)
			},
			remoteMethod(list, query) {
				if (query !== '') {
					// 清除之前的定时器
					if (this.timeout) {
						clearTimeout(this.timeout)
					}
					// 防抖处理，300ms后执行
					this.timeout = setTimeout(() => {
						this.fetchUserOptions(list, query)
					}, 200)
				} else {
					this[list] = []
				}
			},
			fetchUserOptions(list, query) {
				let url =`${this.$store.state.islhurl}user/select-option?keyword=${query}`;
				this._get(url).then().then(res => {
					if(res.code === 200 && res.data) {
						this[list] = res.data;
					} else {
						this[list] = [];
					}
				}).catch(error => {
					this[list] = [];
					console.error('搜索失败:', error)
				})
			},
			searchManager(list, query) {
				if (query !== '') {
					const filterTimeout = setTimeout(() => {
						this[list] = this.projectManagerAllList.filter(item => {
							return item.empCode.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.empName.toLowerCase().indexOf(query.toLowerCase()) > -1;
						});
						clearTimeout(filterTimeout);
					}, 200);
				} else {
					this[list] = [];
				}
			},
			getDeptList() {
				let url =`${this.$store.state.islhurl}dept/getSelectData`;
				let pm = {
					deptCodechain: 'SelectDept',
				}
				this._post(url, pm).then(
					res => {
						this.deptList = res.data;
					}
				)
			},
			getCountry() {
				let url =`${this.$store.state.islhurl}projectManager/fuzzyQueryBySalesRegion?salesRegion=`;
				let params = {
					islhToken : sessionStorage.getItem('islhtoken'),
				}
				this._post(url, params).then(
					res => {
						this.salesRegionList = res;
					}
				)
			},
			validateTime(rule, value, callback) {
				if (rule.field === 'projectPlanStartDate' && this.majorProjectForm.projectPlanEndDate) {
					if (new Date(value) >= new Date(this.majorProjectForm.projectPlanEndDate)) {
						callback(new Error('It must be earlier than Estimated Delivery Start Date'));
					} else {
						callback();
					}
				} else if (rule.field === 'projectPlanEndDate' && this.majorProjectForm.projectPlanStartDate) {
					if (new Date(value) <= new Date(this.majorProjectForm.projectPlanStartDate)) {
						callback(new Error('It must be later than Estimated Delivery Start Date'));
					} else {
						callback();
					}
				} else {
					callback();
				}
			},
			searchIpms(value) {
				if(value && value != '' && value.length > 2) {
					let url =`${this.$store.state.islhurl}majorProject/fuzzyQueryBySystemId?systemId=${value}`;
					let params = {
						islhToken : sessionStorage.getItem('islhtoken'),
					}
					this.searchLoading = true;
					const _this = this;
					this._post(url, params).then(
						res => {  
							this.searchLoading = false;
							if(res) {
								this.ipmsList = res.slice(0, 10);
							}
						}
					).catch((err) => {
						_this.searchLoading = false;
					})
				}
			},
			changeChannelName(value) {
				if(value) {
					const index = this.channelNameList.findIndex((name) => name.companyName === value);
					this.majorProjectForm.channelQualification = this.channelNameList[index].partnershipCategory;
				} else {
					this.majorProjectForm.channelQualification = '';
				}
			},
			searchChannelName(value) {
				if(value && value != '' && value.length > 2) {
					let url =`${this.$store.state.islhurl}majorProject/channelPartner/fuzzyQueryByName?partner=${encodeURIComponent(value)}`;
					let params = {
						islhToken : sessionStorage.getItem('islhtoken'),
					}
					this.searchLoading = true;
					const _this = this;
					this._post(url, params).then(
						res => {  
							this.searchLoading = false;
							if(res) {
								this.channelNameList = res.slice(0, 10);
							}
						}
					).catch((err) => {
						_this.searchLoading = false;
					})
				}
			},
			async querySearchAsync(queryString, cb) {
				if (queryString && queryString != '' && queryString.length > 2) {
					try {
						let url =`${this.$store.state.islhurl}majorProject/fuzzyQueryBySystemId?systemId=${queryString}`;
						const response = await axios.post(url, {
							params: { islhToken : sessionStorage.getItem('islhtoken') }
						});
						const suggestions = [];
						response.data.forEach(item=>{
							suggestions.push({
								value: item
							})
						})
						console.log('Suggestions:', suggestions);
						// 调用回调函数，将建议列表传递给组件
						cb(suggestions);
					} catch (error) {
						console.error('Error fetching suggestions:', error);
						cb([]);
					}
				} else {
					cb([]);
				}
			},
			getIpmsInfo(item) {
				const value = item.value;
				if(value != '') {
					let url =`${this.$store.state.islhurl}majorProject/getBySystemId?systemId=${value}`;
					let params = {
						islhToken : sessionStorage.getItem('islhtoken'),
					}
					this._post(url, params).then(
						res => {  
							if(res && res.data) {
								const info = res.data;
								this.majorProjectForm = {
									...this.majorProjectForm,
									projectName: info.projectName,
									serviceContractList: info.serviceContractList ? info.serviceContractList.join(',') : '',
									productOrderList: info.productOrderList ? info.productOrderList.join(',') : '',
									projectServiceOrderList: info.projectServiceOrderList ? info.projectServiceOrderList.join(',') : '',
									projectProductOrderList: info.projectProductOrderList ? info.projectProductOrderList.join(',') : '',
									productType: info.productType,
									// estimatedProjectAmount: info.estimatedProjectAmount,
									// estimatedServiceAmount: info.estimatedServiceAmount,
								}
								this.customerInfoForm = {
									...this.customerInfoForm,
									customerName: info.customerName,
									customerIndustry: info.customerIndustry,
								}
							}
						}
					)
				}
			},
			beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 200;
        if (!isLt2M) {
          this.$message.error('File cannot be larger than 200MB!');
          return false;
        }
      },
      handleExceed() {
        this.$message.warning('Only one file is allowed for upload.');
      },
			handlePreview(row) {
				if(row.fileAliasName && row.fileName) {
          window.open(`${this.$store.state.islhurl}s3/download?fileAliasName=${encodeURIComponent(row.fileAliasName)}&fileName=${encodeURIComponent(row.fileName)}`);
        }
			},
			changeFile(row) {
				const file = row.file;
				let fd = new FormData();
				fd.append('file', file);
				let params = {
					islhToken: sessionStorage.getItem("islhtoken"),
				}
				fd.append('fileParam', new Blob([JSON.stringify(params)], {type: 'application/json'}));
				let url = `${this.$store.state.islhurl}projectFile/upload`
				// 创建 CancelToken
				const CancelToken = axios.CancelToken;
				const source = CancelToken.source();
				this.cancelUpload = source.cancel; // 存储取消函数
				this._post(url, fd, {
					cancelToken: source.token, // 绑定 CancelToken
					onUploadProgress: (percent) => {
						this.fileList = [{
							name: file.name,
							uid: file.uid,
							uploadPercentage: percent === 100 ? 99 : percent,
						}];
						// 通知Upload组件内部进度更新
					},
					noProgress: true // 禁用全局NProgress
				}).then(res => {
					if(res.code == 200) {
						this.fileList = [{
							name: file.name,
							uid: file.uid,
							id: res.data,
							uploadPercentage: 100,
						}];
						this.projectConfigurationForm = {
							...this.projectConfigurationForm,
							preSalesSolution: file,
						};
						this.preSalesPlanFileId = res.data
						this.$refs.projectConfigurationForm.clearValidate(['preSalesSolution']);
					} else {
						this.fileList = [];
						this.$message.error(res.message || 'Failed!' );
					}
				}).catch(error => {
					console.log(error)
					this.fileList = [];
				})
      },
			beforeRemove() {
				if(this.editDisabled) {
					return false;
				}
			},
			handleRemove() {
				if(this.editDisabled) {
					return false;
				}
				if (typeof this.cancelUpload === 'function') {
					this.cancelUpload('User canceled upload');
					this.cancelUpload = null;
				}
				this.fileList = [];
				this.projectConfigurationForm.preSalesSolution = [];
				this.preSalesPlanFileId = ''
			},
			handleSubmit() {
				this.$refs.majorProjectForm.validate((valid1) => {
					if (valid1) {
						const values = this.majorProjectForm;
						if(
							(!values.productOrderList || values.productOrderList.trim() == '') &&
							(!values.serviceContractList || values.serviceContractList.trim() == '') &&
							(!values.projectProductOrderList || values.projectProductOrderList.trim() == '') &&
							(!values.projectServiceOrderList || values.projectServiceOrderList.trim() == '')
						) {
							this.$message.error('Product Order, Service Contract, Project Order (Product) and Project Order (Service) can not all be empty!' );
							return false;
						}
						this.$refs.customerInfoForm.validate((valid2) => {
							if (valid2) {
								this.$refs.keyPersonnelForm.validate((valid3) => {
									if (valid3) {
										this.$refs.projectConfigurationForm.validate((valid4) => {
											if (valid4) {
												this.$refs.riskManagementForm.validate((valid5) => {
													if (valid5) {
														if(this.majorProjectForm.majorProjectLevel && this.majorProjectForm.majorProjectLevel !== 4) {
															this.$refs.milestonelist.$refs.milestoneForm.validate((valid6) => {
																if (valid6) {
																	this.applyPorject('submitLoading')
																} else {
																	this.activeTab = '7';
																	return false;
																}
															});
														} else {
															this.applyPorject('submitLoading')
														}
													} else {
														this.activeTab = '5';
														return false;
													}
												});
											} else {
												this.activeTab = '4';
												return false;
											}
										});
									} else {
										this.activeTab = '3';
										return false;
									}
								});
							} else {
								this.activeTab = '2';
								return false;
							}
						});
					} else {
						this.activeTab = '1';
						return false;
					}
				});
			},
			clearFormValidate() {
				this.$refs.majorProjectForm.clearValidate();
				this.$refs.customerInfoForm.clearValidate();
				if(this.page !== 'projectDetail') {
					this.$refs.keyPersonnelForm.clearValidate();
					this.$refs.projectConfigurationForm.clearValidate();
					this.$refs.riskManagementForm.clearValidate();
				}
			},
			handleSave() {
				const _this = this;
				this.clearFormValidate();
				this.$refs.majorProjectForm.validateField('ipmsId',(err) => {
					if (!err) {
						_this.$refs.majorProjectForm.validateField('projectName',(err) => {
							if (!err) {
								this.applyPorject('saveLoading')
							} else {
								this.activeTab = '1';
							}
						})
					} else {
						this.activeTab = '1';
					}
				})
			},
			applyPorject(loading) {
				let params = {
					...this.majorProjectForm,
					...this.customerInfoForm,
					...this.keyPersonnelForm,
					...this.projectConfigurationForm,
					...this.riskManagementForm,
          islhToken : sessionStorage.getItem('islhtoken'),
          eosToken : sessionStorage.getItem('eostoken'),
				}
				params.projectPlanStartDate = params.projectPlanStartDate ? moment(params.projectPlanStartDate).format('YYYY-MM-DD HH:mm:ss') : '';
				params.projectPlanEndDate = params.projectPlanEndDate ? moment(params.projectPlanEndDate).format('YYYY-MM-DD HH:mm:ss') : '';
				params.s3s2sManagementStartDate = params.s3s2sManagementStartDate ? moment(params.s3s2sManagementStartDate).format('YYYY-MM-DD HH:mm:ss') : '';
				params.serviceContractList = params.serviceContractList && params.serviceContractList.trim() !== '' ? params.serviceContractList.split(',') : [];
				params.productOrderList = params.productOrderList && params.productOrderList.trim() !== '' ? params.productOrderList.split(',') : [];
				params.projectServiceOrderList = params.projectServiceOrderList && params.projectServiceOrderList.trim() !== '' ? params.projectServiceOrderList.split(',') : [];
				params.projectProductOrderList = params.projectProductOrderList && params.projectProductOrderList.trim() !== '' ? params.projectProductOrderList.split(',') : [];
				const milestoneList = 
					this.majorProjectForm.majorProjectLevel && this.majorProjectForm.majorProjectLevel !== 4 ?
					this.$refs.milestonelist.milestoneForm.tableData : [];
				let milestoneNewList = [];
				let timeJudge = 0;
				const planStartDate = moment(params.projectPlanStartDate, 'YYYY-MM-DD HH:mm:ss').hours(0).minutes(0).seconds(0);
				const planEndDate = moment(params.projectPlanEndDate, 'YYYY-MM-DD HH:mm:ss').hours(0).minutes(0).seconds(0);
				milestoneList.forEach((item, index) => {
					milestoneNewList.push({
						...item,
						majorProjectId: this.id,
						taskLeader: item.taskLeader ? item.taskLeader.join(',') : '',
						islhToken: sessionStorage.getItem('islhtoken'),
						eosToken: sessionStorage.getItem('eostoken'),
						startTime: item.startTime ? moment(item.startTime).format('YYYY-MM-DD HH:mm:ss') : '',
						endTime: item.endTime ? moment(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
						serialNumber: item.serialNumber === 999 ? 999 : index + 1,
					})
					if(loading !== 'saveLoading') {
						const startTime = moment(item.startTime, 'YYYY-MM-DD HH:mm:ss').hours(0).minutes(0).seconds(0);
						const endTime = moment(item.endTime, 'YYYY-MM-DD HH:mm:ss').hours(0).minutes(0).seconds(0);
						if (item.startTime && startTime.isBefore(planStartDate)) {
							timeJudge = 1;
						} else if (item.endTime && endTime.isAfter(planEndDate)) {
							timeJudge = 2;
						} else if (item.startTime && item.endTime && endTime.isBefore(startTime)) {
							timeJudge = 3;
						}
					}
				})
				if(this.majorProjectForm.majorProjectLevel && this.majorProjectForm.majorProjectLevel !== 4) {
					params.milestoneList = milestoneNewList;
				}
				if(timeJudge == 1) {
					this.$message.error('Project Milestone Planning Start Date cannot be earlier than Estimated Delivery Start Date!' );
					this.activeTab = '7';
					return false;
				} else if(timeJudge == 2) {
					this.$message.error('Project Milestone Planning End Date cannot be later than Estimated Delivery Finish Date!' );
					this.activeTab = '7';
					return false;
				} else if(timeJudge == 3) {
					this.activeTab = '7';
					this.$message.error('Project Milestone Planning End Date cannot be earlier than Start Date!' );
					return false;
				}
				let fd = new FormData();
				// Object.keys(params).forEach(key => {
				// 	if(params[key] !== undefined && params[key] !== null && key !== 'preSalesSolution' && key !== 'projectApplyRiskType'){
				// 		fd.append(key, params[key]);
				// 	}
				// })
				let projectApplyRiskTypeNew = []
				params.projectApplyRiskType.forEach(item => {
					if(item.isRisk) {
						projectApplyRiskTypeNew.push({
							riskType: item.riskTypeKey,
							id: item.id,
							riskDesc: item.riskDesc,
							responseMeasures: item.responseMeasures,
						})
					}
				})
				params.riskList = projectApplyRiskTypeNew;
				delete params.projectApplyRiskType;
				delete params.preSalesSolution;
				Object.keys(params).forEach(key => {
					if(params[key] === null ){
						params[key] === '';
					}
				})
				console.log(this.fileList)
				// // 附件
				if(this.fileList && this.fileList.length > 0) {
					if(this.fileList[0].fileAliasName) {
						params.preSalesPlanFileAliasName = this.fileList[0].fileAliasName;
						params.preSalesPlanFileName = this.fileList[0].fileName;
					} else {
						// fd.append('file', this.fileList[0].raw);
					}
					params.preSalesPlanFileId = this.preSalesPlanFileId
				} else {
					// fd.append('file', '');
					params.preSalesPlanFileId = ''
				}
				console.log('params', params)
				fd.append('majorProject', new Blob([JSON.stringify(params)], {type: 'application/json'}))
				let url =`${this.$store.state.islhurl}majorProject/apply`;
				if(loading === 'saveLoading') {
					url =`${this.$store.state.islhurl}majorProject/add`;
				}
				this[loading] = true;
				const _this = this;
				this._post(url, fd).then(
					res => {
						if(res.code === 200) {
							this.$Message.success(loading === 'saveLoading' ? 'Save successful!' : 'Submit successful!' );
							if(loading !== 'saveLoading') {
								if(this.page !== '') {
									this.$emit('closeDetail', 'refresh');
								}
								this.refreshInfo(this.majorProjectForm.majorProjectLevel);
							} else {
								this.majorProjectForm.id = res.data.id;
								let projectApplyRiskType = [];
								const newRisk = res.data.riskList;
								this.projectApplyRiskTypeInit.forEach(item => {
									const index = newRisk.findIndex((risk) => risk.riskType === item.labelKey);
									projectApplyRiskType.push({
										...item,
										id: index > -1 ? newRisk[index].id: null,
										isRisk: index > -1 ? 1: 0,
										riskType: item.labelValue,
										riskTypeKey: item.labelKey,
										riskDesc: index > -1 ? newRisk[index].riskDesc: '',
										responseMeasures: index > -1 ? newRisk[index].responseMeasures: '',
									})
								})
								this.riskManagementForm =  {
									projectApplyRiskType,
								}
								if(this.majorProjectForm.majorProjectLevel && this.majorProjectForm.majorProjectLevel !== 4){
									_this.$refs.milestonelist.setData(res.data.milestoneList);
								}
							}
							// if(this.$route.params.page) {
							// 	this.$router.push({ name: this.$route.params.page });
							// }
						} else {
							this.$message.error(res.message || 'Failed!' );
						}
						this[loading] = false;
					}
				).catch((err) => {
					_this[loading] = false;
        }); 
			},
			refreshInfo(majorProjectLevel) {
				this.activeTab = '1';
				this.majorProjectForm = {
					majorProjectCategoryList: [],
					projectTypeList: [],
					projectPlanStartDate: null,
					projectPlanEndDate: null,
					s3s2sManagementStartDate: null,
					deliveryLabourHour: undefined,
				};
				this.fileList = [];
				this.customerInfoForm = {};
				this.keyPersonnelForm = {};
				this.projectConfigurationForm = {};
				this.riskManagementForm = {
					projectApplyRiskType: [],
				};
				this.formallyForm = {},
				this.officialReleaseFileList = [];
				this.getSelectInfo()
				if(majorProjectLevel && majorProjectLevel !== 4){
					this.$refs.milestonelist.setData([]);
				}
				if(!this.id) {
					this.$nextTick(() => {
						this.clearFormValidate();
					});
				}
			},
			handleBack() {
				// this.$router.push({ name: this.$route.params.page });
				this.activeTab = '1';
				this.$emit('closeDetail');
			},
			openCustomer() {
				this.$refs.customerlist.customerDialog = true;
			},
			setCustomerName(name) {
				this.customerInfoForm = {
					...this.customerInfoForm,
					customerName: name,
				}
			},
			changeDirectCustomerSigning(value) {
				if(value === 1) {
					this.majorProjectForm = {
						...this.majorProjectForm,
						channelName: '',
						channelQualification: '',
					}
				}
			},
			changeWhitelistCustomers(value) {
				const index = this.customerLevelAll.findIndex((level) => level.labelKey === 4);
				if(value === 0) {
					this.customerInfoForm.customerLevel = 4;
					this.customerLevel = [this.customerLevelAll[index]];
				} else if(value === 1) {
					if(this.customerInfoForm.customerLevel === 4) {
						this.customerInfoForm.customerLevel = null;
					}
					this.customerLevel = this.customerLevelAll.slice(0, index);
				}
			},
      handleClick(tab) {
        if(tab.name === '7' && !this.editDisabled) {
          this.$refs.milestonelist.setLastData(this.majorProjectForm, this.keyPersonnelForm);
        }
      },
			setDays(days) {
				this.majorProjectForm.deliveryLabourHour = days;
			},
			setMgmt(days) {				
				this.majorProjectForm.mgmtHours = days;
			},
			setDelivery(days) {
				this.majorProjectForm.deliveryHours = days;
			},
			changeMilestone() {
				if(this.majorProjectForm.majorProjectLevel && this.majorProjectForm.majorProjectLevel !== 4) {
        	this.$refs.milestonelist.setLastData(this.majorProjectForm, this.keyPersonnelForm);
				}
			},
		},
		watch:{
			'majorProjectForm.majorProjectLevel':{
				handler(newVal,oldVal){
					const {mgmtActualHours,estVsActHoursRatio}=this.majorProjectForm;
					if(!mgmtActualHours){
						this.majorProjectForm.mgmtActualHours=0;
					}
					if(!estVsActHoursRatio){
						this.majorProjectForm.estVsActHoursRatio=0;
					}
					// this.majorProjectForm.mgmtHours=null;
				},
				deep:true,
				immediate:true,
			}
		},
	}
</script>
<style lang="less" scoped>
#projectApplication {
	.hiddenBorder {
		box-shadow: none;
		border: none;
	}
	.el-form {
		padding: 20px 0;
		/deep/.el-input {
			max-width: 350px;
		}
		/deep/.el-autocomplete {
			width: 100%;
			max-width: 350px;
		}
		/deep/.el-form-item__label {
			line-height: 22px;
			padding: 9px 12px 9px 12px;
		}
		/deep/.el-input-number {
			width: 100%;
			.el-input__inner {
				text-align: left;
			}
		}
		.custom-input-number{
			width: 69%;
			position: relative;
			display: inline-block;
		}
		.custom-input-number .suffix{
			position: absolute;
			right: 20px;
			top: 50%;
			transform: translateY(-50%);
			color: #606266;
			pointer-events:none;
		}
		.custom-input-number .el-input-number .el-input__inner{
			padding-right: 25px !important;
		}
		/deep/.el-select {
			width: 100%;
			.el-select__tags {
				max-width: 350px!important;
			}
		}
		/deep/.el-form-item__content .el-input__suffix {
			left: auto;
			right: 10px;
		}
		/deep/.el-range-editor.el-input__inner {
			width: 100%;
			max-width: 350px;
		}
		/deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip {
			display: none !important;
		}
		.risk-row {
			padding: 0 20px;
			h3 {
				font-weight: 5800;
			}
			p {
				font-size: 13px;
				padding: 10px 0 0 0;
			}
			.el-form-item {
				// margin-bottom: 0;
			}
		}
		.ipmslabel {
			/deep/.el-form-item__label {
				color: #e73131;
				font-weight: bolder;
			}
		}
		/deep/.icon-label {
			position: absolute;
			right: -22px;
			top: 11px;
			font-size: 19px;
		}
		/deep/.el-tag.el-tag--info {
			color: #606266;
		}
		.longlabel {
			/deep/.el-form-item__label {
				padding: 0 12px;
				line-height: 20px;
			}
		}
	}
}
.el-upload-newlist {
	width: 300px;
	.el-upload-file-box {
		margin-top: 10px;
		border-radius: 4px;
		position: relative;
		line-height: 26px;
		.file-name {
			line-height: 26px;
			color: #606266;
			display: block;
			margin-right: 40px;
			overflow: hidden;
			padding-left: 4px;
			text-overflow: ellipsis;
			-webkit-transition: color .3s;
			transition: color .3s;
			white-space: nowrap;
			i {
				margin-right: 7px;
    		color: #909399;
			}
		}
		.file-name:hover {
			color: #409eff;
		}
		label {
			position: absolute;
			right: 5px;
			top: 0;
			line-height: inherit;
			i {
				line-height: 26px;
			}
			.icon-close {
				cursor: pointer;
			}
			.percentage {
				color: #666;
				font-size: 12px;
			}
		}
	}
	.el-upload-file-box:hover {
		background-color: #f5f7fa;
		.icon-check, .percentage {
			display: none;
		}
		.icon-close {
			display: block !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/view/major/projectApplication/index.vue